// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Fv","wrapper":"i_Fw","body":"i_Fx","input":"i_Fy","label":"i_Fz","mandatory":"i_F0","disallowed":"i_F1"};